<template>
  <div class="consult-main">
    <div class="title">{{ title }}</div>
    <div class="sub-title">请留下您的联系方式    我们将第一时间与您沟通</div>
    <div class="content">
      <a-form layout="inline" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            v-decorator="['name', { rules: [{ required: true, message: '请输入姓名!' }] }]"
            placeholder="称呼姓名"
          >
            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            v-decorator="['phone', { rules: [{
              required: true,
              message: '请输入手机号!'
            }, {
              validator: checktelphone,
            }] }]"
            placeholder="联系电话"
          >
            <a-icon slot="prefix" type="phone" style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <div class="btns">
          <a-form-item>
            <a-button type="primary" html-type="submit">
              信息提交
            </a-button>
          </a-form-item>
        </div>
      </a-form>
      <div id="captcha" />
    </div>
  </div>
</template>

<script>
import { simpleInformationCollection } from '@/apis/index'
export default {
  name: 'ConsultForm',
  props: {
    title: {
      type: String,
      default: '咨询服务 立即预约'
    },
    infoSources: {
      type: String,
      default: '首页'
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'connact' }),
      captchaIns: null,
      params: null
    }
  },
  computed: {
    getCrumbs() {
      return this.$store.state.Breadcrumb.crumbsList
    }
  },
  mounted() {
    this.getCode()
  },
  methods: {
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/
      if (value && !(reg.test(value))) {
        callback('请输入正确的手机号码！')
      } else {
        callback()
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.captchaIns.popUp()
          this.params = {
            infoSources: this.infoSources,
            officialWebsiteEntrance: 'PC',
            name: values.name,
            phone: values.phone
          }
        }
      })
    },
    getCode() {
      const that = this
      // eslint-disable-next-line no-undef
      initNECaptcha && initNECaptcha({
        element: '#captcha',
        captchaId: '6c0483e901164a789d9d13f0291ba257',
        mode: 'popup',
        width: '320px',
        // enableClose: true,
        onClose: function() {
          // 弹出关闭结束后将会触发该函数
        },
        onVerify: function(err, data) {
          if (err) return
          that.params.pictureCode = data.validate
          simpleInformationCollection(that.params).then(res => {
            that.$message.success('感谢您的信息提交，我们将会有专员与您联系~')
            that.captchaIns.refresh()
            that.form.resetFields()
          }).catch(err => {
            that.$message.error(err)
            that.captchaIns.refresh()
          })
        }
      }, function(instance) {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        that.captchaIns = instance
      }, function(err) {
        console.log(err)
        // 初始化失败后触发该函数，err对象描述当前错误信息
      })
    }
  }
}
</script>

<style lang="less" scoped>
.consult-main {
  height: 300px;
  background: url('~@/assets/images/consult-bg.png') no-repeat 0 0;
  padding: 24px 0 28px;
  text-align: center;
  .title {
    font-size: 36px;
    font-weight: 500;
    color: #595961;
    line-height: 50px;
  }
  .sub-title {
    margin-top: 41px;
    font-size: 18px;
    color: #8B8FA1;
    line-height: 24px;
  }
  .content {
    padding-top: 21px;
    /deep/ .ant-input {
      height: 46px;
      font-size: 16px;
      width: 314px;
    }
    .btns {
      // width: 232px;
      // margin-top: 20px;
      text-align: center;
      .ant-btn-primary {
        width: 232px;
        height: 46px;
        background: #3986FF;
        font-size: 16px;
      }
    }
    /deep/ .ant-form-inline .ant-form-item {
      margin-bottom: 24px;
    }
    /deep/ .ant-form-inline .ant-form-item-with-help {
      margin-bottom: 0;
    }
    /deep/ .ant-form-explain {
      line-height: 24px;
    }
  }
}
</style>
